import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchStation = createAsyncThunk(
  'Station/fetchStation',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
       const res =await axios.get(`${BaseUrl}/stations`,{       headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, });
       const result = await res.data;
       return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);




const StarionSlice = createSlice({
  name: 'Station',
  initialState: { Starions: [], loading: false, error: null },
  reducers: {},
  extraReducers: {
    //fetch
    [fetchStation.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchStation.fulfilled]: (state, action) => {
      state.Stations = action.payload;
      state.loading = false;
    },
    [fetchStation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },




  },
});

export default StarionSlice.reducer;
